import { createAction } from '@poa/state';


export const fetchById = createAction('share-links/fetchById', id => ({ id }));
export const fetchByIdSuccess = createAction('share-links/fetchByIdSuccess', data => ({
  data
}));
export const fetchByIdFailed = createAction('share-links/fetchByIdFailed', () => ({}));

export const setDates = createAction('setDates', (
  { startDate, endDate }) => ({
  startDate,
  endDate
}));

export const setChartType = createAction('setChartType', (
  { chartType }) => ({
  chartType
}));